import { createAction, props } from '@ngrx/store';
import { FormMode } from './api-key-form.model';
import {
  ApiKeyCreatedProps,
  ApiKeyErroredProps,
  ApiKeyRequestedProps,
  ApiKeyLoadedProps,
} from './types';

export const AdminApiKeyFormPageRequestedAction = createAction(
  '[Admin Api Key Form] Page Requested',
  props<ApiKeyRequestedProps>(),
);

export const AdminApiKeyLoadedAction = createAction(
  '[Admin Api Key Form Effect] Api Key Loaded',
  props<ApiKeyLoadedProps>(),
);

export const AdminApiKeyErroredAction = createAction(
  '[Admin Api Key Form Effect] Api Key Errored',
  props<ApiKeyErroredProps>(),
);

export const AdminApiKeyFormModeChangedAction = createAction(
  '[Admin Api Key Form] Form Mode Changed',
  props<{ mode?: FormMode }>(),
);

export const CreateAdminApiKeyAction = createAction(
  '[Admin Api Key Form] Create Api Key',
  props<ApiKeyCreatedProps>(),
);

export const AdminApiKeyCreatedAction = createAction(
  '[Admin Api Key Form Effect] Api Key Created',
  props<ApiKeyLoadedProps>(),
);
